/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The signing algorithm of the key.
 */
export const CreateGcpKmsKeyFormAlgorithm = {
  Rs256: "RS256",
  Es256: "ES256",
} as const;
/**
 * The signing algorithm of the key.
 */
export type CreateGcpKmsKeyFormAlgorithm = ClosedEnum<
  typeof CreateGcpKmsKeyFormAlgorithm
>;

export type CreateGcpKmsKeyForm = {
  /**
   * The signing algorithm of the key.
   */
  algorithm: CreateGcpKmsKeyFormAlgorithm;
  /**
   * Optional. The Speakeasy identity (GCP service-account email or AWS principal ARN) the customer granted on the key for the key-policy / IAM-grant model. Not a secret.
   */
  customerGrantReference?: string | undefined;
  /**
   * The external credential Speakeasy uses to authenticate to the key. Must belong to the same organization and matching cloud family (an aws_kms key requires an aws_iam credential; a gcp_kms key requires a gcp_iam credential).
   */
  externalCredentialId: string;
  /**
   * A human-readable name for the key.
   */
  name: string;
  /**
   * The resource name of the GCP KMS key (projects/.../cryptoKeyVersions/...).
   */
  resourceName: string;
};

/** @internal */
export const CreateGcpKmsKeyFormAlgorithm$outboundSchema: z.ZodMiniEnum<
  typeof CreateGcpKmsKeyFormAlgorithm
> = z.enum(CreateGcpKmsKeyFormAlgorithm);

/** @internal */
export type CreateGcpKmsKeyForm$Outbound = {
  algorithm: string;
  customer_grant_reference?: string | undefined;
  external_credential_id: string;
  name: string;
  resource_name: string;
};

/** @internal */
export const CreateGcpKmsKeyForm$outboundSchema: z.ZodMiniType<
  CreateGcpKmsKeyForm$Outbound,
  CreateGcpKmsKeyForm
> = z.pipe(
  z.object({
    algorithm: CreateGcpKmsKeyFormAlgorithm$outboundSchema,
    customerGrantReference: z.optional(z.string()),
    externalCredentialId: z.string(),
    name: z.string(),
    resourceName: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      customerGrantReference: "customer_grant_reference",
      externalCredentialId: "external_credential_id",
      resourceName: "resource_name",
    });
  }),
);

export function createGcpKmsKeyFormToJSON(
  createGcpKmsKeyForm: CreateGcpKmsKeyForm,
): string {
  return JSON.stringify(
    CreateGcpKmsKeyForm$outboundSchema.parse(createGcpKmsKeyForm),
  );
}
